import React, { useState, useEffect, useRef } from 'react';

import { getInputValue, formatNumericValue, parseInputValue } from '../utils';

import DisplayCost from './DisplayCost';

const PackagingSection = ({ data = {}, totalCost = 0, onChange, isEditable = true }) => {
	const [packaging, setPackaging] = useState({
		cartonAverageQuality: 0,
		polybag: 0,
		gumTapeTagGunSilicaGel: 0,
		hangtagWithString: 0,
		polyAndCartonSticker: 0,
		additionalTagsPriceTag: 0,
		sticker: 0,
		additionalPackagingCost: 0
	});
	const isInitialMount = useRef(true);
	const prevDataRef = useRef(null);

	useEffect(() => {
		const dataString = JSON.stringify(data);
		const prevDataString = JSON.stringify(prevDataRef.current);

		if (dataString === prevDataString) {
			return;
		}

		if (data && Object.keys(data).length > 0) {
			setPackaging({
				cartonAverageQuality: formatNumericValue(data.cartoonAverageQualityCost),
				polybag: formatNumericValue(data.polyBagCost),
				gumTapeTagGunSilicaGel: formatNumericValue(data.gumTapTapGunSilicaGelCost),
				hangtagWithString: formatNumericValue(data.handTagWithStingsCost),
				polyAndCartonSticker: formatNumericValue(data.polyAndCartonStickerCost),
				additionalTagsPriceTag: formatNumericValue(data.additionalTagsOrPriceTagCost),
				sticker: formatNumericValue(data.sticker),
				additionalPackagingCost: formatNumericValue(data.additionalPackagingCost)
			});
		}

		prevDataRef.current = data;
		if (isInitialMount.current) {
			isInitialMount.current = false;
		}
	}, [data]);

	const transformToApiFormat = (updatedPackaging) => {
		return {
			cartoonAverageQualityCost: formatNumericValue(updatedPackaging.cartonAverageQuality),
			polyBagCost: formatNumericValue(updatedPackaging.polybag),
			gumTapTapGunSilicaGelCost: formatNumericValue(updatedPackaging.gumTapeTagGunSilicaGel),
			handTagWithStingsCost: formatNumericValue(updatedPackaging.hangtagWithString),
			polyAndCartonStickerCost: formatNumericValue(updatedPackaging.polyAndCartonSticker),
			additionalTagsOrPriceTagCost: formatNumericValue(updatedPackaging.additionalTagsPriceTag),
			sticker: formatNumericValue(updatedPackaging.sticker),
			additionalPackagingCost: formatNumericValue(updatedPackaging.additionalPackagingCost)
		};
	};

	const notifyChange = (updatedPackaging) => {
		if (onChange && !isInitialMount.current) {
			onChange(transformToApiFormat(updatedPackaging));
		}
	};

	const handleInputChange = (field, value) => {
		const updatedValue = parseInputValue(value);
		const updatedPackaging = { ...packaging, [field]: updatedValue };
		setPackaging(updatedPackaging);
		notifyChange(updatedPackaging);
	};

	return (
		<div className="single-table trims-content mt-5">
			<div className="d-flex justify-content-between mb-2">
				<p>Packaging Cost Metrics</p>
			</div>
			<div className="row">
				<div className="col-md-6 col-sm-12 mb-2">
					<p className="regular-12 gray_dark_02 pb-1">Carton, Average Quality ($)</p>
					<input
						type="number"
						step="0.01"
						value={getInputValue(packaging.cartonAverageQuality)}
						onChange={(e) => handleInputChange('cartonAverageQuality', e.target.value)}
						readOnly={!isEditable}
					/>
				</div>

				<div className="col-md-6 col-sm-12 mb-2">
					<p className="regular-12 gray_dark_02 pb-1">Polybag, 1 Pcs/Body ($)</p>
					<input
						type="number"
						step="0.01"
						value={getInputValue(packaging.polybag)}
						onChange={(e) => handleInputChange('polybag', e.target.value)}
						readOnly={!isEditable}
					/>
				</div>

				<div className="col-md-6 col-sm-12 mb-2">
					<p className="regular-12 gray_dark_02 pb-1">Gum Tape, Tag Gun, Silica Gel, Others ($)</p>
					<input
						type="number"
						step="0.01"
						value={getInputValue(packaging.gumTapeTagGunSilicaGel)}
						onChange={(e) => handleInputChange('gumTapeTagGunSilicaGel', e.target.value)}
						readOnly={!isEditable}
					/>
				</div>

				<div className="col-md-6 col-sm-12 mb-2">
					<p className="regular-12 gray_dark_02 pb-1">Hangtag with String ($)</p>
					<input
						type="number"
						step="0.01"
						value={getInputValue(packaging.hangtagWithString)}
						onChange={(e) => handleInputChange('hangtagWithString', e.target.value)}
						readOnly={!isEditable}
					/>
				</div>

				<div className="col-md-6 col-sm-12 mb-2">
					<p className="regular-12 gray_dark_02 pb-1">Poly and Carton Sticker ($)</p>
					<input
						type="number"
						step="0.01"
						value={getInputValue(packaging.polyAndCartonSticker)}
						onChange={(e) => handleInputChange('polyAndCartonSticker', e.target.value)}
						readOnly={!isEditable}
					/>
				</div>

				<div className="col-md-6 col-sm-12 mb-2">
					<p className="regular-12 gray_dark_02 pb-1">Additional Tags/Price Tag ($)</p>
					<input
						type="number"
						step="0.01"
						value={getInputValue(packaging.additionalTagsPriceTag)}
						onChange={(e) => handleInputChange('additionalTagsPriceTag', e.target.value)}
						readOnly={!isEditable}
					/>
				</div>

				<div className="col-md-6 col-sm-12 mb-2">
					<p className="regular-12 gray_dark_02 pb-1">Sticker ($)</p>
					<input
						type="number"
						step="0.01"
						value={getInputValue(packaging.sticker)}
						onChange={(e) => handleInputChange('sticker', e.target.value)}
						readOnly={!isEditable}
					/>
				</div>
				<div className="col-md-6 col-sm-12 mb-2">
					<p className="regular-12 gray_dark_02 pb-1">Additional Packaging Cost (%)</p>
					<input
						type="number"
						step="0.01"
						value={getInputValue(packaging.additionalPackagingCost)}
						onChange={(e) => handleInputChange('additionalPackagingCost', e.target.value)}
						readOnly={!isEditable}
					/>
				</div>
			</div>
			<div className="row align-items-center m-0 total-row">
				<div className="col-md-6 col-sm-12 mb-2 mb-0">
					<p className="semibold-14 gray_dark_01">Total Packaging Cost</p>
				</div>
				<div className="col-md-6 col-sm-12 mb-2 mb-0">
					<p className="semibold-14 gray_dark_01 float-right">
						<DisplayCost totalCost={totalCost} />
					</p>
				</div>
			</div>
		</div>
	);
};

export default PackagingSection;
